import { IFonts } from '.';

export const DEFAULT_FONTS: IFonts = {
  DEFAULT_FONT_FAMILY: 'IBM Plex Sans',
  DEFAULT_ANDROID_FONT_FAMILY: 'IBMPlexSans-Regular',
  DEFAULT_ANDROID_FONT_FAMILY_ITALIC: 'IBMPlexSans-Italic',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM: 'IBMPlexSans-Medium',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM_ITALIC: 'IBMPlexSans-MediumItalic'
};

export const POPPINS_FONTS: IFonts = {
  DEFAULT_FONT_FAMILY: 'Poppins',
  DEFAULT_ANDROID_FONT_FAMILY: 'Poppins-Regular',
  DEFAULT_ANDROID_FONT_FAMILY_ITALIC: 'Poppins-Italic',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM: 'Poppins-Medium',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM_ITALIC: 'Poppins-MediumItalic'
};
